import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import CareersAdmin from './pages/CareersAdmin';
import Login from './pages/Login';
import Dashboard from './layouts/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
function AdminPage() { return <div className="App"><Dashboard><CareersAdmin /></Dashboard></div>; }

const pageMetadata = {
  '/login': {
    title: 'Sign In | HPPL Careers Admin',
    description: 'Sign in to the secure HPPL careers administration portal.',
  },
  '/admin': {
    title: 'Dashboard | HPPL Careers Admin',
    description: 'Manage jobs, candidates, and recruitment operations at HPPL.',
  },
};

function DocumentMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = pageMetadata[pathname] || pageMetadata['/admin'];
    document.title = metadata.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', metadata.description);
  }, [pathname]);

  return null;
}

function App() { return <BrowserRouter><DocumentMetadata /><AuthProvider><Routes><Route path="/login" element={<Login />} /><Route element={<ProtectedRoute />}><Route path="/admin" element={<AdminPage />} /></Route><Route path="/" element={<Navigate to="/admin" replace />} /><Route path="*" element={<Navigate to="/admin" replace />} /></Routes></AuthProvider></BrowserRouter>; }
export default App;
